import './EducationBanner.scss';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAccount } from '../../../../shared/contexts/account/AccountContexts';
import { markNotificationsSeen } from '../../../../shared/services/notifications/NotificationService';
import { openMasterclassWithSso } from '../../../../shared/services/masterclass/MasterclassSsoService';

// Reuses the per-account notifications_seen JSONB store (no dedicated table/endpoint). Same key is
// read back as `educationalBannerDismissed` in the account response, so the banner stays hidden
// across devices and refreshes.
const DISMISS_KEY = 'EDUCATIONAL_BANNER';

const EducationBanner: React.FC = () => {
  const { t } = useTranslation();
  const { accountResponse, setShowVideoTutorial, refetchAccountSilently } = useAccount();
  const [hiddenLocally, setHiddenLocally] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  // Wait for the account to load before deciding — avoids flashing the banner to users who
  // already dismissed it on another device. Visible only to superadmins for now.
  // Gość odpada z innego powodu niż reszta: baner uczy prowadzenia WŁASNEGO konta (video, masterclass),
  // a on jest widzem na cudzym — do tego jego zamknięcie zapisałoby się właścicielowi konta.
  if (
    !accountResponse ||
    accountResponse.role === 'GUEST' ||
    accountResponse.educationalBannerDismissed ||
    hiddenLocally
  ) {
    return null;
  }

  const handleHide = () => {
    setIsClosing(true); // play the collapse animation first
    markNotificationsSeen([DISMISS_KEY]).catch((error) =>
      console.error('Failed to persist education banner dismissal:', error)
    );
    // Unmount + refresh the account only after the animation, so the collapse isn't cut short.
    window.setTimeout(() => {
      setHiddenLocally(true);
      void refetchAccountSilently();
    }, 300);
  };

  return (
    <div className={`education-banner${isClosing ? ' education-banner--closing' : ''}`}>
      <button
        type="button"
        className="education-banner__media"
        onClick={() => setShowVideoTutorial(true)}
        aria-label={t('educationBannerWatchQuickStart')}
      >
        <span className="education-banner__illustration img--ai-visibility" />
        <span className="education-banner__play">
          <span className="education-banner__play-icon ico--play" />
        </span>
      </button>

      <div className="education-banner__content">
        <h3 className="education-banner__title">{t('educationBannerTitle')}</h3>
        <p className="education-banner__description">{t('educationBannerDescription')}</p>

        <div className="education-banner__actions">
          <button
            type="button"
            className="btn btn--black btn--sm"
            onClick={() => setShowVideoTutorial(true)}
          >
            <span className="education-banner__icon ico--run" />
            {t('educationBannerWatchQuickStart')}
          </button>
          <button
            type="button"
            className="btn btn--white btn--sm"
            onClick={() => openMasterclassWithSso(accountResponse)}
          >
            <span className="education-banner__icon ico--graduation" />
            {t('educationBannerStartMasterclass')}
          </button>
        </div>
      </div>

      <button type="button" className="education-banner__hide" onClick={handleHide}>
        {t('educationBannerHide')}
      </button>
    </div>
  );
};

export default EducationBanner;
